var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSparkles = function SvgSparkles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10 1 .99 6.01L15 8l-4.01.99L10 15l-.99-6.01L5 8l4.01-.99zM3.333 1l.693 2.807 1.64.693-1.64.693L3.333 8 2.64 5.193 1 4.5l1.64-.693zM4.333 8l.693 2.807 1.64.693-1.64.693L4.333 15l-.693-2.807L2 11.5l1.64-.693z"
  })));
};
export default SvgSparkles;